/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import router from '@/router'
import { i18n } from '@/plugins/i18n'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { vue3Debounce } from 'vue-debounce'

const pinnia = createPinia()
pinnia.use(piniaPluginPersistedstate)

// Types
import type { App } from 'vue'

export function registerPlugins(app: App) {
  app
    .use(router)
    .use(i18n)
    .use(pinnia)
    .directive('debounce', vue3Debounce({ lock: true }))
}
